/*
 *
 */
'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _cache = new Map();
var invisibleCanvas = undefined;
var invisibleContext = undefined;
/*
 *
 */
Entry.Field = /*#__PURE__*/function () {
  function Field(content, blockView, index) {
    (0, _classCallCheck2["default"])(this, Field);
    this.TEXT_LIMIT_LENGTH = 20;
    this._blockView = blockView;
    this._contents = content;
    this._index = index;
  }
  return (0, _createClass2["default"])(Field, [{
    key: "destroy",
    value: function destroy() {
      var svgGroup = this.svgGroup;
      if (svgGroup) {
        svgGroup._isBinded = false;
        $(svgGroup).off('.fieldBindEvent');
      }
      this.destroyOption(true);
    }
  }, {
    key: "command",
    value: function command(forceCommand) {
      var startValue = this._startValue;
      if (!this._blockView.isInBlockMenu && !_.isUndefined(startValue) && (forceCommand || startValue !== this.getValue())) {
        Entry["do"]('setFieldValue', this.pointer(), this._nextValue || this.getValue(), this._code);
        delete this._nextValue;
        delete this._code;
      }
      delete this._startValue;
    }
  }, {
    key: "destroyOption",
    value: function destroyOption(skipCommand, forceCommand) {
      var _destroyFunc = _.partial(_.result, _, 'destroy');
      var _removeFunc = _.partial(_.result, _, 'remove');
      _destroyFunc(this.documentDownEvent);
      delete this.documentDownEvent;
      _destroyFunc(this.disposeEvent);
      delete this.documentDownEvent;
      _removeFunc(this.optionGroup);
      delete this.optionGroup;
      delete this._neighborFields;
      _cache.clear();
      invisibleCanvas = undefined;
      invisibleContext = undefined;
      this.isEditing() && Entry.Utils.blur();
      this._isEditing = false;
      skipCommand !== true && this.command(forceCommand);
    }
  }, {
    key: "_attachDisposeEvent",
    value: function _attachDisposeEvent(func) {
      var _this = this;
      var defaultFunc = function defaultFunc(skipCommand) {
        _this.destroyOption(skipCommand);
      };
      func = func || defaultFunc;
      this.disposeEvent = Entry.disposeEvent.attach(this, func);
    }
  }, {
    key: "align",
    value: function align(x, y) {
      var animate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var svgGroup = this.svgGroup;
      if (this._position) {
        if (this._position.x) {
          x = this._position.x;
        }
        if (this._position.y) {
          y = this._position.y;
        }
      }
      var transform = "translate(".concat(x, ",").concat(y, ")");
      if (animate) {
        svgGroup.animate({
          transform: transform
        }, 300, mina.easeinout);
      } else {
        svgGroup.attr({
          transform: transform
        });
      }
      this.box.set({
        x: x,
        y: y
      });
    }

    //get absolute position of field from parent board
  }, {
    key: "getAbsolutePosFromBoard",
    value: function getAbsolutePosFromBoard() {
      var blockView = this._block.view;
      var contentPos = blockView.getContentPos();
      var absPos = blockView.getAbsoluteCoordinate();
      return {
        x: absPos.x + this.box.x + contentPos.x,
        y: absPos.y + this.box.y + contentPos.y
      };
    }

    //get absolute position of field from parent document
  }, {
    key: "getAbsolutePosFromDocument",
    value: function getAbsolutePosFromDocument() {
      var blockView = this._block.view;
      var board = blockView.getBoard();
      var _ref = board || {},
        _ref$scale = _ref.scale,
        scale = _ref$scale === void 0 ? 1 : _ref$scale;
      var contentPos = blockView.getContentPos();
      var absPos = blockView.getAbsoluteCoordinate();
      var offset = blockView.getBoard().svgDom.offset();
      return {
        x: absPos.x + this.box.x + contentPos.x * scale + offset.left,
        y: absPos.y + this.box.y + contentPos.y + offset.top - $(window).scrollTop()
      };
    }

    //get relative position of field from blockView origin
  }, {
    key: "getRelativePos",
    value: function getRelativePos() {
      var contentPos = this._block.view.getContentPos();
      var _this$box = this.box,
        x = _this$box.x,
        y = _this$box.y;
      return {
        x: x + contentPos.x,
        y: y + contentPos.y
      };
    }
  }, {
    key: "truncate",
    value: function truncate() {
      var value = String(this._convert(this.getValue()));
      var limit = this.TEXT_LIMIT_LENGTH;
      var ret = value.substring(0, limit);
      if (value.length > limit) {
        ret += '...';
      }
      return ret;
    }
  }, {
    key: "appendSvgOptionGroup",
    value: function appendSvgOptionGroup() {
      return this._block.view.getBoard().svgGroup.elem('g');
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var data = this._block.params[this._index];
      var contents = this._contents;
      if (contents && !_.isEmpty(contents.reference)) {
        var reference = contents.reference.concat();
        if (reference[0][0] === '%') {
          data = this._block.params[parseInt(reference.shift().substr(1)) - 1];
        }
        if (!data) {
          return data;
        }
        return data.getDataByPointer(reference);
      } else {
        return data;
      }
    }
  }, {
    key: "setValue",
    value: function setValue(value, reDraw) {
      if (this.value === value) {
        return;
      }
      this.value = value;
      var contents = this._contents;
      if (contents && !_.isEmpty(contents.reference)) {
        var ref = contents.reference.concat();
        var index = ref.pop();
        var targetBlock = this._block.params[this._index];
        if (ref.length && ref[0][0] === '%') {
          targetBlock = this._block.params[parseInt(ref.shift().substr(1)) - 1];
        }
        if (ref.length) {
          targetBlock = targetBlock.getDataByPointer(ref);
        }
        targetBlock.params[index] = value;
      } else {
        this._block.params[this._index] = value;
      }
      if (reDraw) {
        this._blockView.reDraw();
      }
    }
  }, {
    key: "_isEditable",
    value: function _isEditable() {
      if (Entry.ContextMenu.visible || this._blockView.getBoard().readOnly) {
        return false;
      }
      var dragMode = this._block.view.dragMode;
      if (dragMode == Entry.DRAG_MODE_DRAG) {
        return false;
      }
      var blockView = this._block.view;
      var board = blockView.getBoard();
      if (board.disableMouseEvent === true) {
        return false;
      }
      var selectedBlockView = board.workspace.selectedBlockView;
      if (!selectedBlockView || board != selectedBlockView.getBoard()) {
        return false;
      }
      if (selectedBlockView.isVerticalMove) {
        return false;
      }
      var root = blockView.getSvgRoot();
      return root == selectedBlockView.svgGroup || $(root).has($(blockView.svgGroup));
    }
  }, {
    key: "_selectBlockView",
    value: function _selectBlockView() {
      var blockView = this._block.view;
      blockView.getBoard().setSelectedBlock(blockView);
    }
  }, {
    key: "_bindRenderOptions",
    value: function _bindRenderOptions() {
      var _this2 = this;
      if (this.svgGroup._isBinded) {
        return;
      }
      this.svgGroup._isBinded = true;
      $(this.svgGroup).off('mouseup.fieldBindEvent touchend.fieldBindEvent').on('mouseup.fieldBindEvent touchend.fieldBindEvent', function (e) {
        if (_this2._isEditable()) {
          _this2._code = _this2.getCode();
          _this2.destroyOption();
          _this2._startValue = _this2.getValue();
          _this2.renderOptions();
          _this2._isEditing = true;
        }
      });
    }
  }, {
    key: "pointer",
    value: function pointer() {
      var _pointer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this._block.pointer([Entry.PARAM, this._index].concat((0, _toConsumableArray2["default"])(_pointer)));
    }
  }, {
    key: "getFontSize",
    value: function getFontSize(size) {
      return size || this._blockView.getSkeleton().fontSize || 10;
    }
  }, {
    key: "getContentHeight",
    value: function getContentHeight() {
      return 20;
    }
  }, {
    key: "_getRenderMode",
    value: function _getRenderMode() {
      var mode = this._blockView.renderMode;
      return mode !== undefined ? mode : Entry.BlockView.RENDER_MODE_BLOCK;
    }
  }, {
    key: "_convert",
    value: function _convert(key, value) {
      value = value !== undefined ? value : this.getValue();
      var reg = /&value/gm;
      if (reg.test(value)) {
        return value.replace(reg, '');
      } else if (this._contents.converter) {
        return this._contents.converter(key, value);
      } else {
        return key;
      }
    }
  }, {
    key: "_updateOptions",
    value: function _updateOptions() {
      var block = Entry.block[this._blockView.type];
      if (!block) {
        return;
      }
      var syntaxes = block.syntax;
      for (var key in syntaxes) {
        var syntax = syntaxes[key];
        if (!syntax) {
          continue;
        }
        if (syntax.length === 0) {
          continue;
        }
        for (var i in syntax) {
          var textParams = syntax[i].textParams;
          if (!textParams) {
            continue;
          }
          textParams[this._index].options = this._contents.options;
        }
      }
    }
  }, {
    key: "_shouldReturnValue",
    value: function _shouldReturnValue(value) {
      var obj = this._block.getCode().object;
      return value === '?' || !obj || obj.constructor !== Entry.EntryObject;
    }
  }, {
    key: "isEditing",
    value: function isEditing(value) {
      return !!this._isEditing;
    }
  }, {
    key: "getDom",
    value: function getDom(query) {
      if (_.isEmpty(query)) {
        return this.svgGroup;
      }
      query = (0, _toConsumableArray2["default"])(query);
      var key = query.shift();
      if (key === 'option') {
        return this.optionGroup;
      }

      //default return value
      return this.svgGroup;
    }
  }, {
    key: "optionDomCreated",
    value: function optionDomCreated() {
      this._blockView.getBoard().workspace.widgetUpdateEvent.notify();
    }
  }, {
    key: "fixNextValue",
    value: function fixNextValue(value) {
      this._nextValue = value;
    }
  }, {
    key: "getFieldRawType",
    value: function getFieldRawType() {
      if (this instanceof Entry.FieldTextInput) {
        return 'textInput';
      } else if (this instanceof Entry.FieldDropdown) {
        return 'dropdown';
      } else if (this instanceof Entry.FieldDropdownDynamic) {
        return 'dropdownDynamic';
      } else if (this instanceof Entry.FieldDropdownExtra) {
        return 'dropdownExtra';
      } else if (this instanceof Entry.FieldKeyboard) {
        return 'keyboard';
      } else if (this instanceof Entry.FieldDynamicText) {
        return 'dynamicText';
      }
      // 마이크로비트 전용
      else if (this instanceof Entry.FieldLed) {
        return 'led';
      } else if (this instanceof Entry.FieldLed2) {
        return 'led2';
      } else if (this instanceof Entry.FieldMusicScale) {
        return 'musicScale';
      }
    }
  }, {
    key: "getTextValueByValue",
    value: function getTextValueByValue(value) {
      switch (this.getFieldRawType()) {
        case 'keyboard':
          return Entry.getKeyCodeMap()[value];
        case 'dropdown':
        case 'dropdownDynamic':
          return _.chain(this._contents.options).find(function (_ref2) {
            var _ref3 = (0, _slicedToArray2["default"])(_ref2, 2),
              optionValue = _ref3[1];
            return optionValue === value;
          }).head().value();
        case 'textInput':
          return value;
      }
    }
  }, {
    key: "getBoard",
    value: function getBoard() {
      return _.result(this._blockView, 'getBoard');
    }
  }, {
    key: "getCode",
    value: function getCode() {
      return _.result(this.getBoard(), 'code');
    }
  }, {
    key: "getTextValue",
    value: function getTextValue() {
      return this.getValue();
    }
  }, {
    key: "getFontFamily",
    value: function getFontFamily() {
      return window.loadFontFamily || EntryStatic.fontFamily || 'NanumGothic';
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this._index;
    }
  }, {
    key: "getTextBBox",
    value: function getTextBBox() {
      if (!invisibleContext) {
        invisibleCanvas = Entry.Dom($('<canvas id="invisibleCanvas"></canvas>'))[0];
        invisibleContext = invisibleCanvas.getContext('2d');
      }
      var value = this.getTextValue();
      if (!value) {
        return {
          width: 0,
          height: 0
        };
      }
      var fontSize = this._font_size || '';
      var key = "".concat(value, "&&").concat(fontSize);
      var bBox = _cache.get(key);
      if (bBox) {
        return bBox;
      }
      var board = this._blockView.getBoard();
      var _board$scale = board.scale,
        scale = _board$scale === void 0 ? 1 : _board$scale;
      invisibleContext.font = "".concat(fontSize, "px ").concat(this.getFontFamily());
      var heightLetter = EntryStatic.heightLetter || 'M';
      bBox = {
        width: Math.round(invisibleContext.measureText(value).width * 100) / 100,
        height: Math.round(invisibleContext.measureText(heightLetter).width * 100) / 100
      };
      if (fontSize && window.fontLoaded && bBox.width && bBox.height) {
        _cache.set(key, bBox);
      }
      return bBox;
    }
  }]);
}();